import DOMPurify from "dompurify";
import React from "react";

interface MarkdownProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
}

const convertMarkdownToHTML = (markdown: string): string =>
  markdown
    // Headers
    .replace(/^### (.*$)/gim, "<h3>$1</h3>")
    .replace(/^## (.*$)/gim, "<h2>$1</h2>")
    .replace(/^# (.*$)/gim, "<h1>$1</h1>")
    // Bold & Italic
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.*?)\*/g, "<em>$1</em>")
    // Links
    // eslint-disable-next-line no-useless-escape
    .replace(/\[([^\[]+)\]\(([^\)]+)\)/g, '<a href="$2">$1</a>')
    // Unordered Lists
    .replace(/^\* (.*$)/gim, "<ul><li>$1</li></ul>")
    // Ordered Lists
    .replace(/^\d\. (.*$)/gim, "<ol><li>$1</li></ol>")
    // Adding line breaks
    .replace(/\n$/gim, "<br />");

const MARKDOWN_ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "strong",
  "em",
  "a",
  "ul",
  "ol",
  "li",
  "br",
];
const MARKDOWN_ALLOWED_ATTR = ["href"];

const Markdown: React.FC<MarkdownProps> = ({
  text,
  ...rest
}: MarkdownProps) => (
  <div
    {...rest}
    // eslint-disable-next-line react/no-danger -- sanitized with DOMPurify
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(convertMarkdownToHTML(text), {
        ALLOWED_TAGS: MARKDOWN_ALLOWED_TAGS,
        ALLOWED_ATTR: MARKDOWN_ALLOWED_ATTR,
      }),
    }}
  />
);

export { Markdown };
